// extracted by mini-css-extract-plugin
export default {"card":"CardButton_card__tb-qV","link":"CardButton_link__6-mhM"};